import { useEffect, useMemo, useState } from "react";

export default function VariationModal({
  productId,
  onClose,
  onAdd,
}) {
  const [product, setProduct] = useState(null);

  const [selectedOptions, setSelectedOptions] =
    useState({});

  const [qty, setQty] = useState(1);

  useEffect(() => {
    fetch(`http://localhost:3001/products/${productId}`)
      .then((res) => res.json())
      .then((data) => {
        const productData = data.data || data;

        setProduct(productData);

        const firstAvailable =
          productData.variations?.find(
            (v) => v.qty > 0,
          );

        if (firstAvailable) {
          const options = {};

          Object.keys(firstAvailable).forEach(
            (key) => {
              if (
                ![
                  "id",
                  "price",
                  "salePrice",
                  "qty",
                  "image",
                  "discount",
                  "expire",
                ].includes(key)
              ) {
                options[key] =
                  firstAvailable[key];
              }
            },
          );

          setSelectedOptions(options);
        }
      });
  }, [productId]);

  const variationFields = useMemo(() => {
    if (!product?.variations?.length)
      return [];

    return Object.keys(
      product.variations[0],
    ).filter(
      (key) =>
        ![
          "id",
          "price",
          "salePrice",
          "qty",
          "image",
          "discount",
          "expire",
        ].includes(key),
    );
  }, [product]);

  const selectedVariation = useMemo(() => {
    if (!product?.variations)
      return null;

    return product.variations.find(
      (variation) =>
        variationFields.every(
          (field) =>
            variation[field] ===
            selectedOptions[field],
        ),
    );
  }, [
    product,
    selectedOptions,
    variationFields,
  ]);

  useEffect(() => {
    setQty(1);
  }, [selectedVariation]);

  if (!product) {
    return (
      <div className="modal-overlay">
        <div className="modal">
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{product.name}</h2>

        {variationFields.map((field) => {
          const values = [
            ...new Set(
              product.variations.map(
                (v) => v[field],
              ),
            ),
          ];

          return (
            <div
              key={field}
              style={{
                marginBottom: "15px",
              }}
            >
              <label>
                {field
                  .charAt(0)
                  .toUpperCase() +
                  field.slice(1)}
              </label>

              <select
                value={
                  selectedOptions[field] ||
                  ""
                }
                onChange={(e) =>
                  setSelectedOptions(
                    (prev) => ({
                      ...prev,
                      [field]:
                        e.target.value,
                    }),
                  )
                }
              >
                {values.map((value) => (
                  <option
                    key={value}
                    value={value}
                  >
                    {value}
                  </option>
                ))}
              </select>
            </div>
          );
        })}

        {selectedVariation && (
          <>
            <div
              style={{
                marginBottom: "15px",
              }}
            >
              <p>
                Price:
                {" "}
                $
                {selectedVariation.salePrice ||
                  selectedVariation.price}
              </p>

              <p>
                Stock:
                {" "}
                {selectedVariation.qty}
              </p>

              {selectedVariation.expire && (
                <p>
                  Expire:
                  {" "}
                  {
                    selectedVariation.expire
                  }
                </p>
              )}
            </div>

            <div className="qty-selector">
              <button
                type="button"
                onClick={() =>
                  setQty((prev) =>
                    Math.max(
                      1,
                      prev - 1,
                    ),
                  )
                }
              >
                -
              </button>

              <input
                type="number"
                value={qty}
                min="1"
                max={
                  selectedVariation.qty
                }
                onChange={(e) => {
                  const value =
                    Number(
                      e.target.value,
                    ) || 1;

                  setQty(
                    Math.max(
                      1,
                      Math.min(
                        value,
                        selectedVariation.qty,
                      ),
                    ),
                  );
                }}
              />

              <button
                type="button"
                onClick={() =>
                  setQty((prev) =>
                    Math.min(
                      prev + 1,
                      selectedVariation.qty,
                    ),
                  )
                }
              >
                +
              </button>
            </div>
          </>
        )}

        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            disabled={
              !selectedVariation ||
              selectedVariation.qty ===
                0
            }
            onClick={() =>
              onAdd({
                ...product,

                price:
                  selectedVariation.price,

                salePrice:
                  selectedVariation.salePrice,

                selectedVariation,

                selectedGift: null,

                qty,
              })
            }
          >
            Add To Cart
          </button>

          <button onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}